export default __webpack_public_path__ + "static/media/aws-sqs.0bee1792.svg";